import { Head } from "@inertiajs/react"

export interface UnsfMeta {
  title: string
  description: string
  canonical_url: string
  og: {
    title: string
    description: string
    url: string
    type: string
    image: string
    image_width: number
    image_height: number
    image_type: string
    image_alt: string
    site_name: string
    locale: string
  }
  twitter: {
    card: string
    title: string
    description: string
    image: string
  }
  product_jsonld?: Record<string, unknown> | null
}

interface BreadcrumbItem {
  name: string
  url: string
}

interface UnsfHeadProps {
  meta: UnsfMeta
  breadcrumbs?: BreadcrumbItem[]
}

export default function UnsfHead({ meta, breadcrumbs }: UnsfHeadProps) {
  const breadcrumbLd = breadcrumbs && breadcrumbs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((b, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: b.name,
      item: b.url,
    })),
  } : null

  return (
    <Head>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={meta.canonical_url} />
      <meta property="og:title" content={meta.og.title} />
      <meta property="og:description" content={meta.og.description} />
      <meta property="og:url" content={meta.og.url} />
      <meta property="og:type" content={meta.og.type} />
      <meta property="og:image" content={meta.og.image} />
      <meta property="og:image:width" content={String(meta.og.image_width)} />
      <meta property="og:image:height" content={String(meta.og.image_height)} />
      <meta property="og:image:type" content={meta.og.image_type} />
      <meta property="og:image:alt" content={meta.og.image_alt} />
      <meta property="og:site_name" content={meta.og.site_name} />
      <meta property="og:locale" content={meta.og.locale} />
      <meta name="twitter:card" content={meta.twitter.card} />
      <meta name="twitter:title" content={meta.twitter.title} />
      <meta name="twitter:description" content={meta.twitter.description} />
      <meta name="twitter:image" content={meta.twitter.image} />
      {breadcrumbLd && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbLd)}
        </script>
      )}
      {meta.product_jsonld && (
        <script type="application/ld+json">
          {JSON.stringify(meta.product_jsonld)}
        </script>
      )}
    </Head>
  )
}
